export default "__VITE_ASSET__ff946354__"